import s from './vacation-modal.module.scss'
import classNames from 'classnames'
import { Modal } from '@shared/ui/modal/modal';
import { FetchingDiv } from '@shared/ui/fetching-div/fetching-div';
import { Button } from '@shared/ui/button/button';
import { IconBeach, IconCircleCheck } from '@tabler/icons-react';
import { useProfile } from '@shared/api/useProfile';
import { useUpdateVacation } from '@entities/profile/api/useUpdateVacation';
import { useVacationModal } from '../../model/use-vacation-modal';

const VACATION_EFFECTS = [
	'Новые записи будут недоступны: триальное, разовое занятие и занятие с внешней оплатой',
	'Запись по активному пакету останется доступной для текущих учеников',
	'Слоты расписания будут скрыты для учеников без активного пакета',
	'Покупка новых пакетов будет недоступна, предложения на анкете будут скрыты',
];

export const VacationModal = () => {
	const { isOpen, close } = useVacationModal()

	const { data: profile, isLoading } = useProfile()
	const vacationEnabled = !!profile?.vacation_enabled
	const { mutate: updateVacation, isPending } = useUpdateVacation();

	const toggleVacation = () => {
		updateVacation({ vacation_enabled: !vacationEnabled }, { onSuccess: () => close() })
	}

  return (
		<Modal style={{
			content: {
				width: 'calc(100% - 40px)',
				maxWidth: '420px',
				maxHeight: 'calc(100svh - 40px)',
			}
		}} {...{ isOpen, close }} title={'Отпуск'}>
			<FetchingDiv className={s.card} isFetching={isLoading}>
				<div className={classNames(s.status, vacationEnabled && s.statusActive)}>
					<IconBeach size={20} />
					{vacationEnabled ? 'Отпуск включён' : 'Отпуск выключен'}
				</div>
				<span className={s.caption}>
					{vacationEnabled
						? 'Вы находитесь в отпуске. Запись на занятия для новых учеников отключена.'
						: 'Включите отпуск, чтобы временно отключить запись новых учеников.'}
				</span>
				<div className={s.effects}>
					<span className={s.effectsTitle}>Что происходит, когда отпуск включён</span>
					<ul className={s.effectsList}>
						{VACATION_EFFECTS.map((effect) => (
							<li key={effect} className={s.effectsItem}>
								<IconCircleCheck size={16} className={s.effectsIcon} />
								{effect}
							</li>
						))}
					</ul>
				</div>
				<Button
					label={vacationEnabled ? 'Выключить отпуск' : 'Включить отпуск'}
					theme={vacationEnabled ? 'secondary' : 'primary'}
					className={s.btn}
					fetching={isPending}
					onClick={toggleVacation}
				/>
			</FetchingDiv>
		</Modal>
  );
}
